import { createContext } from "react";

export const NavbarContext = createContext({
    showSearchBar: false,
    setShowSearchBar: () => {},
})